export default "__VITE_ASSET__DEXS_rCM__"